import React, { Component } from 'react';
import { source } from 'react-aim';
import { dispatch } from '@rematch/core';
import { Icon, Label, Button, Modal, Divider } from "semantic-ui-react";
import Accordion from '@zippytech/react-toolkit/Accordion';
import '@zippytech/react-toolkit/Accordion/index.css';

import Summary from './ActiveInitiative/Summary';
import Schedule from './ActiveInitiative/Schedule';
import Status from './ActiveInitiative/Status';
import Notes from './ActiveInitiative/Notes';
import NotesModal from './../Drive/modals/Notes';
import FileUploader from '../../../drive/Attachments/UppyFileUpload';
import InitiativeLogs from './CompletedInitiative/InitiativeLogs'
import objectId from '../../../../helpers/objectId';
import { singleLineText, urlValidation } from '../../../common/RegexValidation';
import { Form } from 'formsy-semantic-ui-react';
import Tags from "../../lifecycleDesigner/ResourcesPane/IndesignComponent/Tags";
import ShowInitiativeMetaData from "../../../../components/workspace/lifecycleDesigner/drive/modals/ShowInitiativeMetaData";
var moment = require('moment');
@source({
    mouseEnter: (props, component) => dispatch.app.setHelpContext("Resource Pane")
})
class ActiveInitiative extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            clickStatus: '',
            openDashboard: false,
            linkOpen: false,
            validForm: false,
            modalFlag: false,
            postProcessingModalFlag: false,
            preProcessingModalFlag: false,
        }
    }

    handleUppyModalClick = () => {
        this.setState({
            openDashboard: !this.state.openDashboard
        });
    }

    close = () => {
        this.setState({ linkOpen: false, name: '', url: '' })
    }

    addLink = () => {
        let attachments = this.props.selectedDataById && this.props.selectedDataById.attachments ? this.props.selectedDataById.attachments : [];
        let document = {};
        document.documentName = this.state.name;
        document.documentId = objectId();
        document.documentUrl = this.state.url;
        document.uploadedBy = this.props.user && this.props.user._id;
        document.uploadedAt = moment();
        attachments.unshift(document);
        this.addAttachment(attachments)
        this.close()
    }

    addAttachment = (attachments) => {

        let attachmentPayload = {
            id: this.props.selectedDataById._id,
            attachments: attachments
        }
        dispatch.initiatives.updateInitiative(attachmentPayload);
    }

    notesClick = (open, clickStatus) => {
        this.setState({ open: open, clickStatus: clickStatus })
    }

    onHandleTag = (tags) => {
        let tagspayload = {
            id: this.props.selectedDataById._id,
            tags: tags
        }
        dispatch.initiatives.updateInitiative(tagspayload);

    }
    // Below isWorkspaceOwner & isDesigner functions are added for KLM-8942 
    isWorkspaceOwner = () => {
        // const loggdinUserId = this.props.user._id;
        let authors =
            this.props.currentOrganization &&
            this.props.currentOrganization.users &&
            this.props.currentOrganization.users.filter(
                (el) =>
                    el.accountUserId === this.props.user._id &&
                    el.role === "workspaceOwner"
            );
        if (authors && authors.length > 0) {
            return true;
        }
        return null;
    };
    isDesigner = () => {
        if(this.props.initiativeOwnerDetails.email === this.props.user.email) {
            return true
        }
        return null
    }
    setMetadataSchemaModalFlag = (flag) => {
        this.setState({ modalFlag: flag });
    };
    setPostProcessingModalFlag = (flag) => {
        this.setState({ postProcessingModalFlag: flag });
    };
    setPreProcessingModalFlag = (flag) => {
        this.setState({ preProcessingModalFlag: flag });
    };
    render() {
        var metaDataFlag = false;
        let postProcessingDataFlag = false;
        let preProcessingDataFlag = false;
        // if(this.props.selectedDataById.createdBy===this.props.user._id){
        //     metaDataFlag = true;
        // }
        // Below changes made for KLM-8942
        if (this.isWorkspaceOwner() || this.isDesigner()) {
            metaDataFlag = true;
            postProcessingDataFlag = true;
            preProcessingDataFlag = true;
        }
        const errorLabel = <div className="customErrorLabel" />;
        const expandTool = <div className="plusMinusIcons"  >
            <Icon className="close" name="plus circle" />
            <Icon className="open" name="minus circle" />
        </div>

        let counts = {}

        if (this.props.selectedDataById) {
            counts.attachmentsLength = <Label>{this.props.selectedDataById.attachments && this.props.selectedDataById.attachments.length}</Label>
            counts.notesLength = <Label>{this.props.selectedDataById.notes && this.props.selectedDataById.notes.length}</Label>
            counts.initiativeLogLength = <Label>{this.props.selectedDataById.initativeLogs && this.props.selectedDataById.initativeLogs.length}</Label>
            counts.tagsLength = <Label>{this.props.selectedDataById.tags && this.props.selectedDataById.tags.length}</Label>
        }

        return (this.props.selectedDataById ?
            <div className="accordianBox w_100">
                <div className="accordianPanel w_100">
                    <Accordion
                        expandTool={expandTool} horizontal enableKeyboardNavigation={false}>
                        {[
                            <div tabTitle="Summary" >
                                <div className="acc-header">Summary</div>
                                <div>
                                    <Summary {...this.props} />
                                </div>
                            </div>,
                            <div tabProps={{ title: 'Schedule' }} >
                                <div className="acc-header">Schedule</div>
                                <div>
                                    <Schedule {...this.props} />
                                </div>
                            </div>,
                            // {/* <div tabProps={{ title: 'Status' }} key="3">
                            //     <div className="acc-header">Status</div>
                            //     <div>
                            //         <Status {...this.props} />
                            //     </div>
                            // </div> */}
                            <div tabTitle={<div>Comments {counts.notesLength} </div>} key="4">
                                <div className="acc-header">Comments {counts.notesLength}

                                    {(this.props.selectedDataById.status === 1 || this.props.selectedDataById.status === 2) &&
                                        <Icon name='plus' className="cursor-pointer" color='green' onClick={() => this.notesClick(true, "addNote")} />
                                        // <span className="pull-right">
                                        //     <Button className="button-submit" size="tiny" onClick={() => this.notesClick(true, "addNote")} >Add Notes</Button>
                                        // </span>
                                    }
                                </div>
                                <div>
                                    <Notes
                                        notes={this.props.selectedDataById && this.props.selectedDataById.notes}
                                        user={this.props.user}
                                        notesClick={this.notesClick}
                                        status={this.props.selectedDataById && this.props.selectedDataById.status}
                                        selectedData={this.props.selectedDataById}
                                        string='intiativeOverview'
                                        role={this.props.selectedOrganisation.role}
                                    />
                                </div>
                            </div>,

                            <div tabTitle={<div>Attachments {counts.attachmentsLength} </div>} key="5">
                                <div className="acc-header">Attachments {counts.attachmentsLength}
                                    {/* <Icon name='plus' id="modalButton" className="cursor-pointer" color='green' onClick={this.handleUppyModalClick} /> */}
                                    <span className="pull-right" style={{ margin: "4px 0px" }}>
                                        <Button className="button-info float-right" style={{ padding: "7px 10px" }} content='Upload File' onClick={this.handleUppyModalClick} />
                                        <Button className="button-info float-right" style={{ padding: "7px 10px" }} content='Add Link' onClick={() => this.setState({ linkOpen: true })} />
                                    </span>
                                </div>
                                <FileUploader
                                    data={this.props.selectedDataById}
                                    action={this.addAttachment}
                                    entityName="initiative"
                                    openDashboard={this.state.openDashboard}
                                    handleUppyModalClick={this.handleUppyModalClick}
                                    selectedOrganization={this.props.selectedOrganisation}
                                    selectedInitiative={this.props.selectedDataById}
                                    to='initiative'
                                />
                            </div>,
                            <div tabTitle={<div>Tags {counts.tagsLength}</div>} key="7">
                                <div className="acc-header">Tags  {counts.tagsLength}</div>
                                <div>
                                    <Form
                                        noValidate
                                    >
                                        <Tags
                                            module="initiative"
                                            tags={this.props.selectedDataById.tags}
                                            onHandleTag={this.onHandleTag}
                                            editAccess={true}
                                        />
                                    </Form>
                                </div>
                            </div>,
                            <div tabTitle={<div>Initiative Logs {counts.initiativeLogLength}</div>} key="5">
                                <div className="acc-header">Initiative Logs {counts.initiativeLogLength}</div>
                                <div>
                                    <InitiativeLogs
                                        user={this.props.user}
                                        selectedDataById={this.props.selectedDataById}
                                    />
                                </div>
                            </div>,
                            <div tabTitle="MetaData">
                                <div className="acc-header">
                                    MetaData
                                    <span
                                        style={{ margin: "0 20px" }}
                                        className="clr-gray fs_italic"
                                    >
                                    {(metaDataFlag && this.props.selectedDataById &&
                                        this.props.selectedDataById.metaData) ? (
                                            <Button
                                            disabled={!metaDataFlag}
                                            content="Edit"
                                            className="button-submit float-right "
                                            type="button"
                                            onClick={() => this.setMetadataSchemaModalFlag(true)}
                                            />
                                        ) : null}
                                    </span>
                                </div>
                                {this.props.selectedDataById &&
                                    this.props.selectedDataById.metaData ? (
                                    <div className="resourcePaneOverflow">
                                        <pre>
                                        {JSON.stringify(
                                            this.props.selectedDataById.metaData,
                                            null,
                                            2
                                        )}
                                        </pre>
                                    </div>
                                ) : <span className="clr-orange">No metaData to display</span>}
                            </div>,

                        ].filter(elem => !!elem)}
                    </Accordion>
                    <NotesModal notes={this.props.selectedDataById.notes}
                        selectedData={this.props.selectedDataById}
                        user={this.props.user}
                        open={this.state.open}
                        clickStatus={this.state.clickStatus}
                        notesClick={this.notesClick}
                        currentNote={this.props.currentNote}
                        string='intiativeOverview' />


                    <Modal
                        className="basicModal"
                        open={this.state.linkOpen}
                        size='mini'
                        onClose={this.close}
                        closeOnEscape={true}
                        closeOnDimmerClick={false}
                        closeIcon
                    >
                        <Modal.Header>Add File</Modal.Header>
                        <Divider style={{ margin: "10px 0 0px" }} />
                        <Modal.Content scrolling>
                            <Form noValidate
                                ref={ref => this.form = ref}
                                id="AddLink"
                                onValid={(e) => this.setState({ validForm: true })}
                                onInvalid={(e) => this.setState({ validForm: false })}
                            >
                                <Form.Input
                                    required
                                    name="Add Link Name"
                                    id="Add Link Name"
                                    label="Add Link Name"
                                    value={this.state.name}
                                    placeholder="Add Link Name"
                                    validations={{ matchRegexp: singleLineText }}
                                    errorLabel={errorLabel}
                                    validationErrors={{
                                        matchRegexp: 'Max limit is 128. No space allowed in starting.',
                                        isDefaultRequiredValue: `Link Name is required`,
                                    }}
                                    onChange={(e) => {
                                        this.setState({ name: e.target.value.trim() })
                                    }}
                                    instantValidation={true}
                                    autoFocus={true}
                                />

                                <Form.Input
                                    required
                                    name="Add Url"
                                    id="Add Url"
                                    label="Add Url"
                                    value={this.state.url}
                                    placeholder="Add Url"
                                    validations={{ matchRegexp: urlValidation }}
                                    errorLabel={errorLabel}
                                    validationErrors={{
                                        matchRegexp: 'Enter valid URL',
                                        isDefaultRequiredValue: `Url is required`,
                                    }}
                                    onChange={(e) => {
                                        this.setState({ url: e.target.value.trim() })
                                    }}
                                    instantValidation={true}
                                />
                            </Form>
                        </Modal.Content>
                        <Modal.Actions className="actionInFormcy border-none pad_0" style={{ "text-align": "right", margin: "0px 0px 15px -15px" }}>
                            <Button disabled={!this.state.validForm} content='Add Link' className="button-submit float-right" type="button" onClick={this.addLink} />
                            <Button content="Cancel" className="button-cancel" type="button" onClick={this.close} />
                        </Modal.Actions>
                    </Modal>

                </div>
                <ShowInitiativeMetaData
                open={this.state.modalFlag}
                setMetadataSchemaModalFlag={this.setMetadataSchemaModalFlag}
                selectedInitiative={this.props.selectedDataById}
                metaData={
                    this.props.selectedDataById &&
                    this.props.selectedDataById.metaData
                }
                view="intiative"
                />
            </div> : ''
            
        )
    }
}



export default ActiveInitiative;

